
import { PAYMENT_SYSTEM_TYPES } from 'app/core/constants'

// controller mixins
DashboardSetupCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * DashboardSetupCtrl controller
 *
 * @class DashboardSetupCtrl
 * @memberof mwApp/home
 * @see mwApp/home
 *
 * @ngdoc controller
 * @name mwApp/home.controller:DashboardSetupCtrl
 */
/* @ngInject */
export default function DashboardSetupCtrl ($scope, $http, $location, dashboardSetup, authSvc) {
  var vm = this
  if (authSvc.hasEnabledFlag('FEATURE_SECURED_DASHBOARD_ENABLED') && !authSvc.hasAccess('editDashboard')) {
    $location.url('403')
  }

  $scope.loading = false

  vm.paymentInformationCards = ['AUTOPAY_PAYMENTS_CARD', 'ALL_PAYMENTS_CARD', 'CASH_PAYMENTS_CARD', 'AUTHORIZE_PAYMENTS_CARD', 'CHECK_PAYMENTS_CARD', 'EXTERNAL_PAYMENTS_CARD', 'CCPP_PAYMENTS_CARD', 'GR4VY_PAYMENTS_CARD', 'GOCARDLESS_PAYMENTS_CARD', 'TRUE_MONEY_PAYMENTS_CARD', 'TRUE_ONLINE_PAYMENTS_CARD', 'TRUE_MOVE_H_PAYMENTS_CARD', 'AIRWALLEX', 'PAYPAL_PAYMENTS_CARD']

  $scope.$watch('vm.settings[\'PAYMENTS_BY_TYPES_GRAPH\'].systemTypes', () => {
    const setting = vm.settings.PAYMENTS_BY_TYPES_GRAPH
    if (!setting.systemTypes.length && setting.paymentsDynamicsByTypes) {
      setting.paymentsDynamicsByTypes = false
    }
  }, true)

  /**
   * Payment system types
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @name vm.payment_system_types
   * @type {Object}
   */
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  /**
   * DashboardSetup settings
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @type {Object}
   */
  vm.settings = dashboardSetup.settings()

  /**
   * DashboardSetup settings
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @type {Boolean}
   */
  vm.changePaymentDynamics = () => {
    const setting = vm.settings.PAYMENTS_BY_TYPES_GRAPH
    if (!setting.paymentsDynamicsByTypes) {
      setting.systemTypes = []
    }

    if (!setting.systemTypes.length && setting.paymentsDynamicsByTypes) {
      setting.systemTypes = Object.keys(vm.payment_system_types)
    }
  }

  /**
   * Checklist with array values
   *
   * @param {Array} list
   */
  vm.checklistModel = (list = []) => (value, form = null) => {
    if (form && form.$pristine) {
      form.$setDirty()
    }
    const index = list.findIndex((l) => l === value)
    if (index === -1) {
      list.push(value)
    } else {
      list.splice(index, 1)
    }
  }

  /**
   * Is include value in array
   *
   * @param {Array} arr
   * @param {any} value
   * @returns {*}
   */
  vm.include = (arr, value) => arr.find((l) => l === value)

  /**
   * Update setup dashboard
   */
  vm.update = () => {
    $scope.loading = true

    dashboardSetup._update(vm.settings)

    setTimeout(() => {
      $scope.loading = false
      $location.url('dashboard')
    }, 0) // Note: timeout for loader
  }

  // dates handling
  const maxDate = new Date()
  const minDate = maxDate.getFullYear() - 1
  vm.openDatePickers = []

  /**
   * Datepicker settings
   *
   * @memberof mwApp/home.controller:DashboardSetupCtrl
   * @type {Object}
   */
  vm.dpCfg = {
    maxDate: new Date(),
    minDate: minDate,
    format: 'dd.MM.yyyy HH:mm',
    openedFROM: false,
    openedTO: false
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/home.controller:DashboardSetupCtrl
   */
  vm.open = function ($event, datePickerIndex) {
    $event.preventDefault()
    $event.stopPropagation()

    vm.openDatePickers[datePickerIndex] = !vm.openDatePickers[datePickerIndex]
  }
}
